/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<dom-module id="cs-media-player-styles">
	<template>
    <style>
      /** * Player Container */:host {
        display: block;
        width: 100%;
      } /** * Ratio */.cspl-media-player__ratio {
        line-height: 0;
        padding-top: 56.25%;
      /* 16:9 ratio */
        position: relative;
      } /** * Cover */.cspl-media-player__cover {
        align-items: center;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        left: 0;
        overflow: hidden;
        position: absolute;
        top: 0;
        width: 100%;
      } /** * This needs to be corrected for the HIGHLIGHT MEDIA * :host-context([open]:not([status="finished"])) .cspl-media-player__cover, */:host([is-touch]) .cspl-media-player__cover, :host([status="playing"]) .cspl-media-player__cover, :host([status="paused"]) .cspl-media-player__cover, :host([status="finished"][rel="1"]) .cspl-media-player__cover, :host([status="finished"][loop="1"]) .cspl-media-player__cover {
        display: none;
      } /** * Cover Image */.cspl-media-player__cover-image {
        display: block;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      } /* ready, finished variant */:host([status="finished"]) .cspl-media-player__cover-image, :host([status="ready"]) .cspl-media-player__cover-image {
        cursor: pointer;
      } /** * Cover Icon */.cspl-media-player__cover-icon {
        cursor: pointer;
        height: 64px;
        position: relative;
        transition: transform .1s cubic-bezier(.5, .25, .015, 1);
        width: 64px;
      }

      :host([hide-play-icon]) .cspl-media-player__cover-icon {
        display: none;
      }

      :host([widget]) .cspl-media-player__cover-icon {
        display: none;
      } /* hover variant */:host(:hover) .cspl-media-player__cover-icon {
        transform: scale(1.05);
      }

      @media only screen and (min-width: 768px) {
        .cspl-media-player__cover-icon {
          height: 104px;
          width: 104px;
        }
      }

      @media only screen and (min-width: 1024px) {
        .cspl-media-player__cover-icon {
          height: 120px;
          width: 120px;
        }
      }

      @media only screen and (min-width: 1456px) {
        .cspl-media-player__cover-icon {
          height: 136px;
          width: 136px;
        }
      } /** * Play Button */.cspl-media-player__cover-icon-play {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }

      :host([_play-intent]) .cspl-media-player__cover-icon-play {
        display: none;
      } /** * Spinner */.cspl-media-player__cover-icon-spinner {
        animation: spin 1s linear infinite;
        color: var(--cs-theme-color);
        display: none;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        will-change: transform;
      }

      :host([_play-intent]:not([status="playing"])) .cspl-media-player__cover-icon-spinner {
        display: block;
      }

      .cspl-media__asset {
        position: relative;
      }

      @keyframes spin {
        to {
          transform: rotate(-360deg);
        }
      }
    </style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
